import Vue from "vue";
import store from "../store/index";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

var npush = Router.prototype.push;
Router.prototype.push = function (loction) {
  return npush.call(this, loction).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
    {
      path: "/",
      component: () => import("@/views/index"),
      meta: {
        title: "",
        description:
          "共瀛科技（宁波）有限公司，主要从事环保水性丙烯乳液的研发、生产和销售，公司核心团队由从业30多年的第一代先驱者及80后年轻创业团队组成，当前公司在成都和上虞化工园区拥有有2个生产基地，北京设立专业研发中心，具有深厚的技术底蕴及研发能力，当前主营的水性丙烯酸系列产品，广泛用于胶粘剂、建筑、包装、工业漆、造纸、纺织皮革、电子及新能源等领域，近年公司发展走定制化路线，可以根据客户要求进行研发定制，也可以为量大客户提供提供OEM代工，欢迎前来洽谈和合作！",
      },
    },
    {
      path: "/about",
      component: () => import("@/views/about"),
    },
    {
      path: "/products",
      component: () => import("@/views/products"),
    },
    {
      path: "/productsmes",
      component: () => import("@/views/productsmes"),
    },
    {
      path: "/news",
      component: () => import("@/views/news"),
    },
    {
      path: "/newsmes",
      component: () => import("@/views/newsmes"),
    },
    {
      path: "/development",
      component: () => import("@/views/development"),
    },
    {
      path: "/contact",
      component: () => import("@/views/contact"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // console.log("tototo", to);
  store.commit("SET_LANG", sessionStorage.getItem("lang") || 1);
  next();
  //每次进入滚动到页面顶部
  window.scrollTo({
    top: 0,
  });
  // if (!to.query.navindex1 && (to.path == '/products' || to.path == '/news') || from.path=='/') {

  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js